import type { Routes } from '@angular/router';
import { AUTH_ROUTES } from './auth/auth.routes';
import { DashboardRoute } from './dashboard/common/enums/dashboard-route';
import { DASHBOARD_ROUTES } from './dashboard/dashboard.routes';

export const ROUTES: Routes = [
  ...AUTH_ROUTES,
  ...DASHBOARD_ROUTES,
  {
    path: '**',
    redirectTo: DashboardRoute.GANTT,
  },
];
